<script lang="ts">
  import Confetti from 'canvas-confetti';
  import { onMount } from 'svelte';
  import { d as starPath } from '~/icons/Star.svelte';
  import { delay } from '~/animations/utils.svelte';

  let canvasRef: HTMLCanvasElement;
  let confetti: Confetti.CreateTypes;

  let innerWidth: number;
  let innerHeight: number;

  const common: Confetti.Options = {
    disableForReducedMotion: true,
    colors: ['#36AE7C'],
    origin: { x: 0.5, y: 0.5 },
    startVelocity: 30,
    gravity: 0.6,
    spread: 90,
    ticks: 100,
  };

  onMount(() => {
    // 1. Multiply the canvas's width and height by the devicePixelRatio
    // const ratio = window.devicePixelRatio || 1
    // console.log(ratio);
    // canvasRef.width = innerWidth * ratio
    // canvasRef.height = innerHeight * ratio

    // // 2. Force it to display at the original (logical) size with CSS or style attributes
    // canvasRef.style.width = innerWidth + 'px'
    // canvasRef.style.height = innerHeight + 'px'

    // // 3. Scale the context so you can draw on it without considering the ratio.
    // const ctx = canvasRef.getContext('2d')
    // ctx?.scale(ratio, ratio)

    confetti = Confetti.create(canvasRef, {
      // useWorker: true,
      resize: true,
    });

    const star = Confetti.shapeFromPath({
      path: starPath,
    });

    delay(250).then(() =>
      confetti({
        ...common,
        particleCount: 20,
        shapes: [star],
      }),
    );
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />
<canvas class="canvas" bind:this={canvasRef}></canvas>

<style>
  .canvas {
    position: fixed;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
</style>
